import { Exception } from '../Exception';

export class UnknownHttpException extends Exception {
  constructor(originalException: unknown) {
    super(undefined, originalException);
  }
}
